/**
 * Route for `campaign-carrier-targeting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignCarrierTargetingPage } from "../features/campaign-carrier-targeting/CampaignCarrierTargetingPage";

export const campaignCarrierTargetingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-carrier-targeting",
	component: CampaignCarrierTargetingPage,
});

export default campaignCarrierTargetingRoute;
